import React from "react";

import SearchInput from "../common/SearchInput";

const accountFilters = [
  <SearchInput
    label="common.search"
    source="q"
    alwaysOn
    resettable
    autoFocus
  />,
];
export default accountFilters;
